import { Amplify } from 'aws-amplify';
import getConfig from '../config';

const configureAmplify = () => {
  const config = getConfig();
  Amplify.configure(config);
};

export default configureAmplify;
